<template>
  <div class="page page-about container is-fluid">
    <div class="container container-inner">
      <div class="columns is-gapless is-multiline">
        <div class="column content" style="margin-top:0;padding-top:0;" data-aos="fade-up" data-aos-once="true" v-if="note && about">
          <img :src="about.image ? about.image.path : ''" class="img-responsive" />
          <div class="box note color-gray-lighter-bg is-hidden-mobile">
            <markdown v-if="note.content" :source="note.content" />
            <!-- <div class="subtitle" style="margin-bottom:0.8em;">
              Collection and Probation Services
            </div>
            <div class="text">
              We provide range of services. Click <a href="/services">here</a> for our list of services.
            </div> -->
          </div>
        </div>
        <div class="column content content-main is-left" data-aos="fade-up" data-aos-once="true" data-aos-delay="300" v-if="about">
          <div class="title">
            {{ about.title }}
          </div>
          <markdown v-if="about.content" :source="about.content" />
          <!-- <div class="text">
            CMS was founded by Ken McClellan, Teresa McClellan, and Amy Kitchens. The company was incorporated in 2005 and began accepting cases in Augues of 2006. Our first court was Warren County Probate Court in Warrenton, Georgia; Janice Thigpen presiding judge. Our second court was Columbia County Probate Court in Evans, Georgia; Pat Hardaway presiding judge.
            <br /><br />
            CMS is registered with Misdemeanor Probation Oversight Unit of Georgia (MPOU). Compliance reviews are performed annually by MPOU on case management practices, compliance with Department of Community Supervision Board Rules and Georgia Statutes and Regulations. CMS has performed exceptional review for 2020 has been waived due to "exceptional efforts" in the industry. We meet our exceed all qualificaitons and standards for private probation providers and maintain liability insurance and all employees are bonded.
            <br /><br />
            It is our goal to provide exceptional service to all of our customers - the person on probation, and all court personnel.
            <br /><br />
            We are a small, family owned business and our staff is committed to providing exceptional service to all courts.
          </div> -->
        </div>
        <div class="column content is-hidden-tablet" style="margin-bottom:0;" data-aos="fade-up" data-aos-once="true" v-if="note">
          <div class="box note color-gray-lighter-bg">
            <markdown v-if="note.content" :source="note.content" />
            <!-- <div class="subtitle" style="margin-bottom:0.8em;">
              Collection and Probation Services
            </div>
            <div class="text">
              We provide range of services. Click <a href="/services">here</a> for our list of services.
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Markdown from 'vue-markdown'
import EventBus from '@/controllers/EventBus'

import Site from '@/apis/Site'

export default {
  name: 'page-about',
  components: {
    Markdown
  },
  data () {
    return {
      isDesktop: true,
      about: undefined,
      note: undefined
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  mounted () {
    // on event resize
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))

    this.getAbout()
    this.getNote()
  },
  methods: {
    async getAbout () {
      try {
        let data
        // about
        this.about = undefined
        data = await Site.aboutNamed('about')
        if (data && data[0]) {
          data = data[0]
          this.about = data
        }
      } catch (error) {
        console.log('about error', error)
      }
    },

    async getNote () {
      try {
        let data
        // note
        this.note = undefined
        data = await Site.aboutNamed('about-note')
        if (data && data[0]) {
          data = data[0]
          this.note = data
        }
      } catch (error) {
        console.log('about error', error)
      }
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";
@import "../styles/page.scss";

// .page-about {
//   .content {
//     a {
//       // text-decoration: underline;
//     }
//   }
// }

</style>



// WEBPACK FOOTER //
// About.vue?7b97e508